import './_styles.scss';
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Grid } from 'react-bootstrap';
import { pickBy, has, isEqual } from 'lodash';
import axios from 'axios';
import qs from 'qs';

import FilterGroup from '../../components/Filters/FilterGroup';
import SearchGroup from '../../components/Search/SearchGroup';
import Pagination from '../../components/Pagination';
import Spinner from '../../components/Loaders/Spinner';
import Tabs from '../../components/Tabs';
import Table from './components/Table';
import ModalsManager from './components/Modals/Manager';

import {
  bulkCancelAndRefund,
  bulkComplete,
  cancelAndRefund,
  complete,
  getConfig,
  getList,
  getListPagination,
  getServices,
} from '../../services/endpoints/drip-feed';
import { pageWrapperScrollTop } from '../../utils/helper';
import Loader from '../../components/Loaders/Loader';

const DripFeed = () => {
  const location = useLocation();
  const history = useHistory();

  const queryString = qs.parse(location.search.slice(1));

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [config, setConfig] = useState({});
  const [values, setValues] = useState([]);
  const [isLoading, setIsLoading] = useState({ page: true, table: false, pagination: false, modalSubmit: false });
  const [openModal, setOpenModal] = useState('');
  const [modalData, setModalData] = useState({});

  const onHideModals = () => {
    setOpenModal('');
  };

  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, table: true }));

    try {
      const response = await getList(queryString);
      const isUpdatePagination = !isEqual(data?.filters, response?.data?.filters)
      if (response.success) {
        setData((prevState) => ({
          ...response.data,
          pagination: isUpdatePagination ? response.data.pagination : {
            ...prevState.pagination,
            current_page: response.data.pagination.current_page,
          },
        }));
      }
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return {
        ...response.data,
        need_pagination: isUpdatePagination,
      };
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return error;
    }
  };

  const fetchListPagination = async () => {
    setIsLoading((prevState) => ({ ...prevState, pagination: true }));

    try {
      const response = await getListPagination(queryString);
      if (response.success) {
        setData((prevState) => ({ ...prevState, pagination: response.data.pagination }));
      }
      setIsLoading((prevState) => ({ ...prevState, pagination: false }));
      return response.data;
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, pagination: false }));
      return error;
    }
  };

  const fetchConfig = async () => {
    try {
      const response = await getConfig();
      if (response.success) {
        setConfig(response.data);
        return response.data;
      }
    } catch (error) {
      return error;
    }
  };

  const fetchServices = async () => {
    try {
      const response = await getServices(queryString);

      if (response?.success) {
        setConfig((prevState) => ({ ...prevState, services: response?.data?.services }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      const configResponse = !init ? await fetchConfig() : config;
      if (configResponse?.access?.list) {
        const listResponse = await fetchList();
        setIsLoading((prevState) => ({ ...prevState, page: false }));
        if (listResponse?.need_pagination) {
          await fetchListPagination();
        } else {
          setIsLoading((prevState) => ({ ...prevState, pagination: false }));
        }
      } else {
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      }
      setInit(true);
    } catch (error) {
      if (axios.isCancel(error)) {
        return;
      }
      setInit(true);
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  };

  const onSortTable = (head) => {
    if (head.active === 'desc') {
      delete queryString.page;
      queryString.sort = head.asc;
    }
    if (head.active === 'asc' || !head.active) {
      delete queryString.page;
      queryString.sort = head.desc;
    }
    return history.push(`${location.pathname}?${(location.search = qs.stringify(queryString))}`);
  };

  const onChangeSelectService = (options) => {
    if (options?.length === 0 && !has(queryString, 'service')) return;
    const newOptions = options.filter((option) => option.id !== null).map((opt) => opt.id);
    const queryObj = {
      ...queryString,
      service: newOptions,
    };
    if (has(queryObj, 'page')) delete queryObj.page;
    history.push({ pathname: location.pathname, search: qs.stringify({ ...pickBy(queryObj) }) });
  };

  const onChangeStatus = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await complete(modalData?.item?.id, 2);
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      fetchList();
    } catch (error) {
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  };

  const onBulkChangeStatus = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await bulkComplete(values, 2);
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      setValues([]);
      fetchList();
    } catch (error) {
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  };

  const onCancelOrder = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await cancelAndRefund(modalData?.item?.id);
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      fetchList();
    } catch (error) {
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  };

  const onBulkCancelOrders = async () => {
    setIsLoading((prevState) => ({ ...prevState, modalSubmit: true }));
    try {
      await bulkCancelAndRefund(values);
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
      setValues([]);
      fetchList();
    } catch (error) {
      onHideModals('');
      setIsLoading((prevState) => ({ ...prevState, modalSubmit: false }));
    }
  };

  const onSubmitModal = (type) => {
    switch (type) {
    case 'confirm':
      if (modalData.actionType === 'single') {
        if (modalData.title === 'Complete') {
          onChangeStatus();
        }
        if (modalData.title === 'Cancel and refund') {
          onCancelOrder();
        }
      }
      if (modalData.actionType === 'mass') {
        if (modalData.title === 'Complete') {
          onBulkChangeStatus();
        }
        if (modalData.title === 'Cancel and refund') {
          onBulkCancelOrders();
        }
      }
      break;

    default:
      break;
    }
  };

  useEffect(() => {
    if (init && queryString.page) {
      pageWrapperScrollTop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString.page]);

  useEffect(() => {
    getAllData();
    setValues([]);

    document.title = 'Drip-feed';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Grid fluid>
      <ModalsManager
        open={openModal}
        isLoadingSubmit={isLoading.modalSubmit}
        modalData={modalData}
        values={values}
        statuses={config?.statuses}
        onSubmit={onSubmitModal}
        onHide={onHideModals}
      />

      <FilterGroup>
        {config?.statuses && <Tabs tab="status" tabsData={config?.statuses} />}
        {config?.access?.list && (
          <SearchGroup
            autocomplete="on"
            sectionName="drip-feed"
            placeholder="Search"
            withSelect
            options={config?.search_types}
            filters={data?.filters}
            disabled={isLoading.page}
          />
        )}
      </FilterGroup>

      {isLoading.page && !init ? (
        <Loader />
      ) : (
        <>
          {config?.access?.list ? (
            <>
              <Table
                isLoading={isLoading.table}
                items={data?.items}
                config={config}
                sort={data?.sort}
                filters={data?.filters}
                values={values}
                setValues={setValues}
                onSortTable={onSortTable}
                setOpenModal={setOpenModal}
                setModalData={setModalData}
                onChangeSelectService={onChangeSelectService}
                fetchServices={fetchServices}
              />

              {isLoading.pagination || isLoading.table ? (
                <div className="pagination">
                  <Spinner />
                </div>
              ) : (
                <Pagination
                  pages={data.pagination?.pages}
                  currentPage={data.pagination?.current_page}
                  itemsCount={data.pagination?.total_count}
                  pageSize={data.pagination?.page_size}
                  pagesLimit={data.pagination?.pages < 10 ? data.pagination?.pages : 10}
                />
              )}
            </>
          ) : null}
        </>
      )}
    </Grid>
  );
};

export default DripFeed;
